import { CheckCircle } from '@mui/icons-material';
import { Box, Stack, styled, Typography, useTheme } from '@mui/material';
import { useState } from 'react';

// Utilities
import ButtonWithLoading from 'src/components/common/ButtonWithLoading';
import PopupContactSales from 'src/features/Pricing/PopupContactSales';

const StyledBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.default,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 12,
}));

const BENEFITS = [
  '180+ countries covered',
  'Extended supply & demand analyses',
  'Ports & vessel tracking',
  'Custom reports included',
  'CSV / XLSX export (BUYERS · SUPPLIERS · BOL)',
  'Full API access & system integration',
  'White-label platform available',
  'Master account & distributor model',
  'Custom personalisation & branding',
];

const EnterprisePlanCard = () => {
  const theme = useTheme();
  const [openContactSales, setOpenContactSales] = useState<boolean>(false);

  return (
    <StyledBox border={`1px solid ${theme.palette.divider}`} borderRadius="12px" height="100%">
      <PopupContactSales open={openContactSales} handleClose={() => setOpenContactSales(false)} />
      <Typography
        variant="h6"
        fontWeight={600}
        sx={{
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitLineClamp: '1',
          lineClamp: '1',
          WebkitBoxOrient: 'vertical',
        }}
      >
        Enterprise
      </Typography>
      <Box mt={1} />
      <Typography
        variant="body2"
        color={'textTertiary.main'}
        sx={{
          height: '60px',
          overflow: 'hidden',
        }}
      >
        Everything in Professional
      </Typography>
      <Stack my={2} spacing={3} direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="h6">FULL POWER</Typography>
      </Stack>
      <ButtonWithLoading fullWidth color="primary" variant="contained" onClick={() => setOpenContactSales(true)}>
        Contact Sales
      </ButtonWithLoading>
      <Stack spacing={1.5} direction="column" mt={2}>
        {BENEFITS.map((benefit, index) => (
          <Stack key={`benefit-enterprise-${index}`} spacing={1} direction="row">
            <CheckCircle color="success" fontSize="small" />
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                width: '90%',
                overflowWrap: 'break-word',
              }}
            >
              {benefit}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </StyledBox>
  );
};

export default EnterprisePlanCard;
